import { CreateProductUpdatePopupDto, ProductUpdatePopupDto } from '@sportspredict/shared';
import api from './base-api';

export const generatedPopupsApi = api.injectEndpoints({
	endpoints: (builder) => ({
		createPopup: builder.mutation<ProductUpdatePopupDto, CreateProductUpdatePopupDto>({
			query: (body) => ({ url: 'generated-popups', method: 'POST', body }),
			invalidatesTags: ['GeneratedPopup'],
		}),

		deletePopup: builder.mutation<void, string>({
			query: (id) => ({ url: `generated-popups/${id}`, method: 'DELETE' }),
			invalidatesTags: ['GeneratedPopup'],
		}),

		getAllPopups: builder.query<ProductUpdatePopupDto[], void>({
			query: () => ({ url: 'generated-popups' }),
			providesTags: ['GeneratedPopup'],
		}),

		getNotViewedPopup: builder.query<ProductUpdatePopupDto | null, void>({
			query: () => ({ url: 'generated-popups/not-viewed' }),
		}),

		markPopupAsSeen: builder.mutation<void, string>({
			query: (id) => ({ url: `generated-popups/${id}/mark-seen`, method: 'POST' }),
		}),
	}),
});

export const {
	useCreatePopupMutation,
	useDeletePopupMutation,
	useGetAllPopupsQuery,
	useGetNotViewedPopupQuery,
	useMarkPopupAsSeenMutation,
} = generatedPopupsApi;
